module.exports = __webpack_public_path__ + "img/styria_media_design_logo.55720249.svg";